export class UpdateContext {
  start_time;
  time;
  deltaTime;
  isDrawFrame;
}
